import { radii } from '../radius.js';
import { colors } from '../colors.js';
import { sizes } from '../sizing.js';
import { space } from '../spacing.js';
export const listBoxBase = {
    borderRadius: radii.x1_5,
    backgroundColor: colors.backgrounds.onGray,
    boxShadow: {
        alpha: 'x3',
        style: 'broad',
        color: 'secondary',
    },
};
export const listBoxSectionLabel = {
    paddingX: space.x3,
    paddingY: space.x2,
};
export const listBoxEmptyState = {
    marginX: space.x3,
    marginY: space.x10,
};
export const listBoxSection = {
    withCheckbox: {
        paddingLeft: space.x3,
    },
    withoutCheckbox: {
        paddingLeft: space.x6,
    },
};
export const listBoxItemBase = {
    cursor: 'pointer',
    height: sizes.x9,
};
export const listBoxItemStates = {
    inactive: {
        color: 'default',
        backgroundColor: 'onGray',
    },
    hovered: {
        color: 'default',
        backgroundColor: 'default',
    },
    active: {
        color: 'primaryActive',
        backgroundColor: 'onGray',
    },
};
//# sourceMappingURL=list-box.js.map